// import React from 'react'
// import './ChallengingCards.scss'
// import { HiOutlineClipboardCheck, HiOutlineLocationMarker } from 'react-icons/hi'
// import { Link } from 'react-router-dom';
// import { Helmet } from "react-helmet";


// //import images
// import K2BaseCampTrek from '../../../../Assets/Treks/K2BaseCampTrek.jpg'
// import BiafoHisparTrek from '../../../../Assets/Treks/BiafoHisparTrek.jpg'
// import BroadPeak from '../../../../Assets/Treks/BroadPeak.jpg'
// import GasherbrumIBaseCamp from '../../../../Assets/Treks/GasherbrumIBaseCamp.jpeg'
// import K7BaseCampTrek from '../../../../Assets/Treks/K7BaseCampTrek.jpg'
// import MasherbrumBaseCamp from '../../../../Assets/Treks/MasherbrumBaseCamp.jpeg'

// const Data = [
//   {
//     id: 1,
//     slug: "k2-base-camp-trek",
//     imgSrc: K2BaseCampTrek,
//     destTitle: 'K2 Base Camp Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'The K2 Base Camp Trek is one of the world’s greatest trekking adventures. It takes you along the Baltoro Glacier to the foot of K2 (8611m), the world’s second-highest mountain, passing iconic peaks like Trango Towers, Masherbrum, and Broad Peak.'
//   },

//   {
//     id: 2,
//     slug: "k2-gandogoro-la-trek",
//     imgSrc: K2BaseCampTrek,
//     destTitle: 'K2 Gandogoro La Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'The K2 Gandogoro La Trek combines the classic K2 Base Camp route with a thrilling high-altitude pass crossing at 5,585m. From the top of Gandogoro La, trekkers witness breathtaking views of K2, Broad Peak, Gasherbrum I–IV, and Masherbrum.'
//   },

//   {
//     id: 3,
//     slug: "broad-peak-base-camp-trek",
//     imgSrc: BroadPeak,
//     destTitle: 'Broad Peak Base Camp Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'This trek leads to the base camp of Broad Peak (8051m), located near Concordia on the Baltoro Glacier. It offers dramatic scenery of the Karakoram giants, including K2, Gasherbrum peaks, and Chogolisa.'
//   },

//   {
//     id: 4,
//     slug: "biafo-hispar-trek",
//     imgSrc: BiafoHisparTrek,
//     destTitle: 'Biafo Hispar Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'The Biafo Hispar Trek connects the Baltistan region with Hunza via a 100 km trail over two massive glaciers — Biafo and Hispar. This trek offers wilderness, snow-capped peaks, and the longest continuous glacial system outside the polar regions.'
//   },

//   {
//     id: 5,
//     slug: "gasherbrum-i-base-camp-trek",
//     imgSrc: GasherbrumIBaseCamp,
//     destTitle: 'Gasherbrum I Base Camp Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'Gasherbrum I (8068m), the 11th highest mountain in the world, is located in the Karakoram. The trek to its base camp passes through Baltoro Glacier and Concordia, surrounded by a panorama of 8000m peaks.'
//   },

//   {
//     id: 6,
//     slug: "k7-base-camp-trek",
//     imgSrc: K7BaseCampTrek,
//     destTitle: 'K7 Base Camp Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'The K7 Base Camp Trek takes trekkers to the foot of K7 (6934m), one of the most striking granite towers in the Karakoram. The route follows lush valleys, glaciers, and offers close-up views of Charakusa Valley peaks.'
//   },

//   {
//     id: 7,
//     slug: "masherbrum-base-camp-trek",
//     imgSrc: MasherbrumBaseCamp,
//     destTitle: 'Masherbrum Base Camp Trek',
//     location: 'Pakistan',
//     grade: 'Challenging',
//     description:
//       'Masherbrum (7821m), also known as K1, is one of the most beautiful peaks in the Karakoram. The trek to its base camp passes through Hushe Valley, remote villages, and offers stunning views of Masherbrum’s snow-clad pyramid.'
//   },
// ]

// const cards = () => {
//   return (
//     <div className="main">
//       <Helmet>
//   <title>Challenging Treks in Pakistan | World Adventures Tours</title>
//   <meta
//     name="description"
//     content="Explore Pakistan’s most challenging treks including K2 Base Camp, Broad Peak Base Camp, Gasherbrum I, Biafo Hispar, and Masherbrum Base Camp. Perfect for adventure seekers looking for thrilling Karakoram experiences."
//   />
//   <meta
//     name="keywords"
//     content="Challenging Treks in Pakistan, K2 Base Camp Trek, Gandogoro La Trek, Broad Peak Base Camp, Gasherbrum I Base Camp, K7 Base Camp, Masherbrum Base Camp, Biafo Hispar Trek, Karakoram Treks, Baltoro Glacier, Concordia Trek, Adventure Pakistan"
//   />
//   <meta name="author" content="World Adventures Tours" />

//   <meta property="og:title" content="Challenging Treks in Pakistan | World Adventures Tours" />
//   <meta
//     property="og:description"
//     content="Join the ultimate adventure with Pakistan’s most demanding treks — from K2 Base Camp to Gasherbrum I and Masherbrum. Experience the majestic Karakoram Range up close."
//   />
//   <meta property="og:image" content="https://www.worldadventurestours.com/Pictures/Treks/Challenging/K2/k2-base-camp-trek.jpg" />
//   <meta property="og:type" content="website" />
//   <meta property="og:url" content="https://worldadventurestours.com/challenging-treks" />
//   <link rel="canonical" href="https://worldadventurestours.com/challenging-treks" />
// </Helmet>

//       <section className='main container section'>
//         <div className="SecTitle">
//           <center><h3>Challenging Treks In Pakistan</h3></center>
//         </div>

//         <div className="secContent grid">
//           {
//             Data.map(({ id, slug, imgSrc, destTitle, location, grade, fees, description }) => {
//               return (
//                 <div key={id} className='singleDestination'>
//                   <div className="imageDiv">
//                     <img src={imgSrc} alt={destTitle} />
//                   </div>

//                   <div className="cardInfo">
//                     <h4 className='destTitle'>{destTitle}</h4>
//                     <span className="continent flex">
//                       <HiOutlineLocationMarker className='icon' />
//                       <h4 className="name">{location}</h4>
//                     </span>

//                     <div className="desc">
//                       <p>{description}</p>
//                     </div>

//                     <Link to={`/${slug}`} className='btn flex'>
//                       DETAILS <HiOutlineClipboardCheck className='icon' />
//                     </Link>
//                   </div>
//                 </div>
//               )
//             })
//           }
//         </div>
//       </section>
//     </div>
//   )
// }

// export default cards;




import React, { useEffect, useState } from 'react'
import './ChallengingCards.scss'
import { HiOutlineLocationMarker } from 'react-icons/hi'
import { Link, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { FaStar } from 'react-icons/fa'

import { IMAGE_BASE_URL } from '../../../../config';
import { fetchCategories, getTripsByCategory } from '../../../../services/tripServices';

const Cards = () => {
  const { category } = useParams();
  const [cat, setCat] = useState(null);
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchCategories().then((res) => {
      const currentCat = res.filter((cat) => (cat.name + "-" + cat.type) === category)
      setCat(currentCat);
    });

    getTripsByCategory(category).then((data) => {
      setTrips(data);
      setLoading(false);
    }).catch((err) => {
      console.error(err);
      setLoading(false)
    })
  }, [category])

  return (
    <div className="main">

      {cat && (
        <Helmet>
          <title>{`${cat.name} ${cat.type} in Pakistan | World Adventures Tours`}</title>
          <meta
            name="description"
            content={cat.description}
          />
          <meta
            name="keywords"
            content={cat.keywords}
          />
          <meta
            property="og:title"
            content={`${cat.name} ${cat.type} in Pakistan | World Adventures Tours`}
          />
          <meta
            property="og:description"
            content={cat.description}
          />
          <meta
            property="og:image"
            content={`${IMAGE_BASE_URL}/${cat.thumbnailImage}`}
          />
          <meta
            property="og:url"
            content={`https://worldadventurestours.com/${category}`}
          />
          <meta
            property="og:type"
            content="website"
          />
          <link
            rel="canonical"
            href={`https://worldadventurestours.com/${category}`}
          />
        </Helmet>
      )}

      <section className="tourcards section container">
        <div className="SecTitle">
          {cat && <center><h3>{cat.name} {cat.type} In Pakistan</h3></center>}
        </div>
        {loading ? (
          <center><p>Loading.....</p></center>
        ) : (
          <div className="cardsGrid">

            {trips && trips.map(item => (
              <div className="tourcard" key={item.id}>

                {/* IMAGE */}
                <div className="cardImage">
                  <img crossOrigin='anonymous' src={`${IMAGE_BASE_URL}/${item.image}`} alt={item.title} />

                  <div className="imageBadges">
                    <span className="badge">
                      <HiOutlineLocationMarker /> {item.location}
                    </span>
                    <span className="badge">{item.days}</span>
                  </div>
                </div>

                {/* BODY */}
                <div className="cardBody">
                  <h3>{item.title}</h3>

                  <div className="reviews">
                    <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                    <span className="reviewsText">Based on {item.reviewsCount} reviews</span>
                  </div>


                  <p className="desc">{item.description}</p>

                  <div className="cardFooter">
                    <span className="price">${item.price}</span>
                    <Link to={`/${item.slug}`} className="detailsBtn">
                      Details
                    </Link>
                  </div>
                </div>

              </div>
            ))}

          </div>
        )}
      </section>
    </div>
  )
}

export default Cards
